export const PageSection = (props) => <div id={props.id} ref={props.reference} className="section py-5 row w-100 no-gutters justify-content-center">{props.children}</div>
